import * as React from "react";
import {Redirect, RouteComponentProps, withRouter} from "react-router";
import { authWithNonce } from "stores/authWithNonce";
import { connect } from "react-redux";
import { ApplicationState } from "stores/index";
import { fetchCookieUser } from "stores/user";

interface IProps {
  authWithNonce: (body: any) => void;
  fetchCookieUser: () => void;
  reset: () => void;
  success: boolean;
  loading: boolean;
  error: boolean;
  errorMessage: string;
}

function getParameterByName(name: string, url?: string) {
  if (!url) url = window.location.href;
  name = name.replace(/[[]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const NewLogin: React.FunctionComponent<
  IProps & RouteComponentProps
> = props => {
  const json = {
    email: getParameterByName("email"),
    nonce: getParameterByName("nonce")
  };

  React.useEffect(() => {
    if (props.success) {
      props.fetchCookieUser();
    }
    else {
      props.authWithNonce(json);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.success]);

  return <React.Fragment>
    {props.success && <Redirect to={"/"}/>}
  </React.Fragment>;
};

export default connect(
  (state: ApplicationState) => ({
    success:
      state.authWithNonce.requested &&
      state.authWithNonce.success,
    loading:
      state.authWithNonce.requested &&
      state.authWithNonce.requesting,
    error:
      state.authWithNonce.requested &&
      !state.authWithNonce.success,
    errorMessage: state.authWithNonce.error
  }),
  { authWithNonce, fetchCookieUser }
)(withRouter(NewLogin));
